<template>
  <div class="modal-mask" @mousedown="$emit('closeModal')">
    <div class="modal-wrapper">
      <div class="modal-container" @mousedown.stop>
        <div class="header">
          <div class="title">회사/단체명 조회</div>
          <div class="close">
            <i class="fal fa-times fa-fw" @click="closeModal"></i>
          </div>
        </div>
        <div class="modal-body">
          <div class="inner-wrap">
            <div class="input-wrap">
              <input
                type="text"
                v-model="manager"
                ref="manager"
                @keyup.enter="searchManager"
                placeholder="회사/단체명"
              />
              <button @click="searchManager">조회하기</button>
            </div>
          </div>
          <slot name="body">
            <div class="companies">
              <div class="table">
                <div class="thead">
                  <div class="row">
                    <div class="col" id="name">
                      <span>기업명</span>
                    </div>
                    <div class="col" id="number">
                      <span>사업자등록번호</span>
                    </div>
                  </div>
                </div>
                <div class="tbody list-box">
                  <div class="no-result" v-show="companies.length === 0">
                    검색결과가 없습니다
                  </div>
                  <div
                    class="row"
                    v-for="result in companies"
                    :key="result._id"
                    @click="selectManager(result)"
                  >
                    <div class="col" id="name">
                      <span>{{ result.vatInfo.companyName }}</span>
                    </div>
                    <div class="col" id="number">
                      <span>
                        {{
                          result.vatInfo.vatNumber
                            ? result.vatInfo.vatNumber.replace(
                                /(\d{3})(\d{2})(\d{5})/,
                                "$1-$2-$3"
                              )
                            : ""
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./../ModalCommon.css" scoped></style>
<style src="@/components/common/Table/index.css"></style>
<style src="./index.css" scoped></style>

<script>
/* eslint-disable */
export default {
  components: {},
  watch: {},
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    selectManager(val) {
      this.$emit("selectManager", {
        companyName: val.vatInfo.companyName,
        _id: val._id,
      });
    },
    async searchManager() {
      if (this.manager.length < 2) {
        alert("법인명은 최소 2자리 이상 입력해야합니다");
        return this.$refs.manager.$el.focus();
      }

      this.companies = [];
      try {
        const result = await this.$store.dispatch("biz_member_find_manager", {
          companyName: this.manager,
        });

        this.loading = false;
        if (!result.success) {
          console.error(result);
          return alert("요청에 오류가 발생하였습니다");
        }
        this.companies = result.result;
      } catch (e) {
        this.loading = false;
        alert("회원가입중 오류가 발생하였습니다");
      }
    },
  },
  created() {
    const vm = this;
    window.addEventListener("keyup", function (e) {
      if (e.key.toLowerCase() === "escape") vm.$emit("closeModal");
    });
  },
  data() {
    return {
      manager: "",
      companies: [],
    };
  },
  computed: {},
  async mounted() {},
};
</script>
